export default {
  CancelReason: "CancelReason",
  AddCancelReason: "AddCancelReason",
  editCancelReason: "EditCancelReason",
};
